import './DocumentAutoFill.scss'
import { defaultValues, mockedsDocuments, almostRealDocuments } from './data'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import isClient from 'utils/isClient'
import { useState } from 'react'
import classNames from 'classnames'

const DocumentAutoFill = ({ formProps: { setValues } }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleAutoFill = (documentNumber, birthDate) => {
    const { name, email, cellphone } = defaultValues
    if (isClient()) {
      setValues({
        document: documentNumber,
        name: name,
        email: email,
        birth_date: birthDate,
        cellphone: cellphone,
      })
      setIsOpen(false)
    }
  }

  const handleFlee = ({ currentTarget: button }) => {
    const formWidth = document.querySelector('.register-form-input').clientWidth

    const randomPositionRight = Math.floor(Math.random() * formWidth)

    button.style.right = `${
      randomPositionRight > formWidth ? formWidth - 60 : randomPositionRight
    }px`
  }

  return (
    <div className="document-autofill-tool">
      <div
        className="document-autofill-tool__button"
        onClick={() => setIsOpen(!isOpen)}
        onMouseOver={Math.random() > 0.9 ? handleFlee : () => null}
      >
        Lista de CPFs
      </div>
      <div
        className={classNames('document-autofill-tool__content', {
          '--isOpen': isOpen,
        })}
      >
        <div className="document-autofill-tool__group">
          <span className="document-autofill-tool__title">Mock</span>
          {mockedsDocuments.map((item, index) => {
            const {
              document_number: documentNumber,
              birth_date: birthDate,
              details,
            } = item
            return (
              <CopyToClipboard
                text={`Os dados utilizados foram:\nCPF: ${documentNumber}\nData de nascimento: ${birthDate}`}
                key={index}
              >
                <div
                  className="document-card"
                  onClick={() => handleAutoFill(documentNumber, birthDate)}
                >
                  <span className="document-card__item">
                    <strong>CPF:</strong> {documentNumber}
                  </span>
                  <span className="document-card__item">
                    <strong>Data de nascimento:</strong> {birthDate}
                  </span>
                  <details
                    className="details"
                    onClick={(evt) => evt.stopPropagation()}
                  >
                    <summary className="details__title">
                      Detalhes<span className="details__icon"></span>
                    </summary>
                    {details.map((detail, index) => (
                      <span className="details__item" key={index}>
                        {detail}
                      </span>
                    ))}
                  </details>
                </div>
              </CopyToClipboard>
            )
          })}
        </div>
        <div className="document-autofill-tool__group">
          <span className="document-autofill-tool__title">CPF</span>
          {almostRealDocuments.map((item, index) => {
            const {
              document_number: documentNumber,
              birth_date: birthDate,
              details,
            } = item
            return (
              <CopyToClipboard
                text={`Os dados utilizados foram:\nCPF: ${documentNumber}\nData de nascimento: ${birthDate}`}
                key={index}
              >
                <div
                  className="document-card"
                  onClick={() => handleAutoFill(documentNumber, birthDate)}
                >
                  <span className="document-card__item">
                    <strong>CPF:</strong> {documentNumber}
                  </span>
                  <span className="document-card__item">
                    <strong>Data de nascimento:</strong> {birthDate}
                  </span>
                  <details
                    className="details"
                    onClick={(evt) => evt.stopPropagation()}
                  >
                    <summary className="details__title">
                      Detalhes<span className="details__icon"></span>
                    </summary>
                    {details.map((detail, index) => (
                      <span className="details__item" key={index}>
                        {detail}
                      </span>
                    ))}
                  </details>
                </div>
              </CopyToClipboard>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DocumentAutoFill
